import { apply, contains, first, last, length } from "@pdfking/rfunc"
import { Items, Keys } from "@pdfking/tfunc"
import fire_event from "@pdfking/workflow/utils/fire_event"
import uuid from "@pdfking/workflow/utils/uuid"
import { defineComponent } from "vue"

const divider = "///"

export default defineComponent({
  computed: {
    is_invalid() {
      return length(this.options_visible) == 0
    },
    label() {
      return last(this.selection.split(divider))
    },
    options_visible() {
      return this.options_for_selection(this.selection)
    },
    placeholder() {
      return this.options_visible[this.current]
    },

    selection: {
      get() {
        return this.find_value(this.current)
      },
      set(value: string) {
        this.current = first(Keys(this.options_for_selection(value)))
      },
    },
    show_second() {
      return length(this.options_visible) >= 1 && first(this.options_visible)
    },
  },
  data() {
    return {
      current: this.value,
      uuid: uuid(),
    }
  },
  emits: ["selection"] as const,

  methods: {
    find_value(v: string) {
      for (const l in this.options) {
        for (const g in this.options[l]) {
          if (contains(this.options[l][g], v)) {
            return this.make_key(l, g)
          }
        }
      }
      return this.make_key("", "")
    },
    first,

    length,
    make_key: (label: string, selection: string) => label + divider + selection,

    options_for_selection(selection: string) {
      return apply(
        (l: string, g: string) => (this.options[l] ? this.options[l][g] : {}),
        selection.split(divider)
      )
    },
  },

  props: ["name", "value", "options", "size_1", "size_2", "disabled"] as const,
  render() {
    return (
      <div class={this.show_second ? "input-group" : ""}>
        <select
          value={this.selection}
          onInput={(e: Event) => {
            this.selection = (e.target as HTMLSelectElement).value
          }}
          class={[
            "form-select prevent-submit-onchange",
            {
              "is-invalid": this.is_invalid,
              "flex-grow-0": this.show_second && this.size_1,
            },
          ]}
          disabled={this.disabled}
          style={{
            width: this.show_second ? this.size_1 : null,
          }}
          title={this.label}
        >
          {this.is_invalid && (
            <option value={this.selection}>{this.value}</option>
          )}
          {Items(this.options || {}).map(([label, inner]: [string, any]) =>
            label ? (
              <optgroup key={label} label={label}>
                {Keys(inner).map((opt: string) => (
                  <option
                    key={this.make_key(label, opt)}
                    value={this.make_key(label, opt)}
                  >
                    {opt}
                  </option>
                ))}
              </optgroup>
            ) : (
              Keys(inner).map((opt: string) => (
                <option
                  key={this.make_key(label, opt)}
                  value={this.make_key(label, opt)}
                >
                  {opt}
                </option>
              ))
            )
          )}
        </select>
        <input
          ref="hidden"
          value={this.current}
          name={this.name}
          type="hidden"
        />
        {this.show_second && (
          <select
            ref="second"
            value={this.current}
            onInput={(e: Event) => {
              this.current = (e.target as HTMLSelectElement).value
            }}
            class={[
              "form-select prevent-submit-onchange",
              { "flex-grow-0": this.size_2 },
            ]}
            disabled={this.disabled || length(this.options_visible) <= 1}
            style={{ width: this.size_2 }}
            title={this.placeholder}
          >
            <optgroup label={this.label}>
              {Items(this.options_visible).map(([id, title]: [string, any]) => (
                <option key={id} value={id}>
                  {title}
                </option>
              ))}
            </optgroup>
          </select>
        )}
        {this.$slots.buttons?.()}
      </div>
    )
  },
  watch: {
    current() {
      ;(this.$refs.hidden as HTMLInputElement).value = this.current
      // @ts-expect-error TS2345 TODO: fix vue tsx types
      fire_event(this.$refs.hidden, "change")
      this.$emit("selection", this.current)
    },
  },
})
